module.exports = __webpack_public_path__ + "img/cant-find.b3338197.webp";